import { Chip } from "@mui/material";
import type { FC } from "react";
import type { ParticipantListStatus } from "./participantListStatus";
import { participantListStatusColors, participantListStatusLabels } from "./participantListStatus";

interface Props {
  readonly status: ParticipantListStatus;
}

const ParticipantListStatusView: FC<Props> = ({ status }) => (
  <Chip label={participantListStatusLabels[status]} style={{ backgroundColor: participantListStatusColors[status] }} />
);

export default ParticipantListStatusView;
